import {Links} from './links.model';
import {Hal} from './hal.model';

export class Team {
  identification: string;
  name: string;
  code: string;
  unassignedCaseCount: number;
  description: string;
  _links: Links;

  constructor(data: any) {
    this.identification = data.identification;
    this.name = data.name;
    this.code = data.code;
    this.unassignedCaseCount = data.unassignedCaseCount ?? 0;
    this.description = data.description ?? '';
    this._links = new Links(data._links)
  }

}

class Embedded {
  teams: Team[];

  constructor(data: any) {
    this.teams = data.teams.map((data: any) => new Team(data));
  }
}

export class TeamHal extends Hal {
  _embedded?: Embedded;

  constructor(data: any) {
    super(data);
    if (!!data._embedded) {
      this._embedded = new Embedded(data._embedded);
    }
  }
}
